export default "__VITE_ASSET__BPGBfPge__"